import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { environment } from '@environments/environment';
import { Binder } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-binder-admin-list',
  imports: [
    CommonModule,
    UiModule,
    RouterModule
  ],
  templateUrl: './binder-admin-list.html',
  styleUrl: './binder-admin-list.css',
})
export class BinderAdminList {
  readonly router=inject(Router);
  readonly binderS=inject(BinderService);
  readonly binders=signal<Binder[]>([]);
  readonly loading=signal(true);

  constructor(){
    this.binderS.getBinders()
      .subscribe(binders => {
        this.binders.set(binders);
        this.loading.set(false);
      });
  }

  getClassState(state: string){
    return {
      'badge-error': state=='disabled',
      'badge-success': state=='actif'
    };
  }
}
